import { render, staticRenderFns } from "./BrandDetail.vue?vue&type=template&id=7b164978&"
import script from "./BrandDetail.vue?vue&type=script&lang=ts&"
export * from "./BrandDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports